import React from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

import { Copyright } from "@/_components";

const FooterLink = styled(Link)({
  textDecoration: "none",
  color: "#1c355e",
  fontSize: 14,
  "&:hover": {
    textDecoration: "underline",
  },
});

function DrawerFooter({ isISA }) {
  const { t } = useTranslation();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const countryUrl =
    countryCode === "AU" ? "au" : countryCode === "EU" ? "eu" : "com";

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid style={{ width: "100%" }}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-evenly"
          style={{ margin: "auto", display: "flex", width: "100%" }}
        >
          <Grid>
            <FooterLink
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/terms-of-use/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("policies.termsofUseLabel")}
            </FooterLink>
          </Grid>
          <Grid>
            <FooterLink
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/privacy-policy/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("policies.privacyLabel")}
            </FooterLink>
          </Grid>
        </Grid>
      </Grid>
      <Grid style={{ width: "100%" }}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-evenly"
          style={{ margin: "auto", display: "flex" }}
        >
          <Grid>
            <FooterLink
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/cookie-policy/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("policies.cookiesLabel")}
            </FooterLink>
          </Grid>
          <Grid>
            <FooterLink
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/quality-policy/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("policies.qualityLabel")}
            </FooterLink>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Copyright isISA={isISA} />
      </Grid>
    </Grid>
  );
}

DrawerFooter.propTypes = {
  isISA: PropTypes.bool,
};

export { DrawerFooter };
